export default function handleOnBlurRelianceIPAHelper(
  event,
  setFieldValue,
  formikValues,
  arrayIndex
) {
  const name = event.target.name;
  const value = event.target.value;
  if (
    formikValues?.primaryDetails[arrayIndex]?.RelationshipWithProposerID ===
    "345"
  ) {
    if (name === `primaryDetails[${arrayIndex}].Gender`) {
      setFieldValue(`proposerDetails.Gender`, value);
    } else if (name === `primaryDetails[${arrayIndex}].Salutation`) {
      setFieldValue(`proposerDetails.Salutation`, value);
    } else if (name === `primaryDetails[${arrayIndex}].OccupationID`) {
      setFieldValue(`proposerDetails.OccupationID`, value);
    }
  }
}
